import React from "react";
import { compose } from "recompose";
import { Table } from "reactstrap";
import {
  AddNewButton,
  withTable,
  EditDeleteButtons,
  Page,
} from "components/common";
import {Trans} from "react-i18next";

export const PublicHolidayList = ({
  TableContainer,
  match,
  data,
  onDeleteItem,
  PayrollTableDataFetch,
  PayrollBulkDeleteButton,
}) => (
  <Page title="Public Holidays" className="inv-table">
    <PayrollBulkDeleteButton className="d-none" />
    <AddNewButton
      resource="Public Holiday"
      match={match}
      className="float-left mb-2"
    />
    <TableContainer>
      <Table>
        <thead>
          <tr>
            <th sortBy="name"><Trans>Name</Trans></th>
            <th sortBy="date"><Trans>Date</Trans></th>
            <th />
          </tr>
        </thead>
        <tbody>
          {data.results.map((i) => (
            <tr key={i.id}>
              <td>{i.name}</td>
              <td>{i.date}</td>
              <td className="text-end text-nowrap">
                <EditDeleteButtons
                  url={match.url}
                  id={i.id}
                  onDelete={onDeleteItem}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>
    <PayrollTableDataFetch />
  </Page>
);

const enhance = compose(withTable({ limit: 99999, url: "public_holidays" }));

export default enhance(PublicHolidayList);
